import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ArrowR16 as IconChevronRight16 } from '@cian/ui-kit/icons';

import * as s from './BreadCrumbsContainer.css';
import { useCurrentBreadCrumbs } from '../../utils';

/**
 * "Хлебные крошки" для текущей локации
 */
export const BreadCrumbsContainer = () => {
  const currentBreadCrumbs = useCurrentBreadCrumbs();

  if (!currentBreadCrumbs?.length) {
    return null;
  }

  return (
    <div className={s['wrapper']}>
      {currentBreadCrumbs.map(({ pathname, breadCrumbName, isParent }, index) => (
        <Fragment key={index}>
          {isParent ? (
            <Link to={pathname} className={s['link']} title={`Перейти в раздел '${breadCrumbName}'`}>
              {breadCrumbName}
            </Link>
          ) : (
            <span className={s['text']}>{breadCrumbName}</span>
          )}

          {index < currentBreadCrumbs.length - 1 && (
            <div className={s['delimiter']}>
              <IconChevronRight16 />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};
